<template>
  <ComponentLayout
    class="add-automation">
    <template #breadcrumbs>
      <Breadcrumbs
        class="pa-0  "
        :items="breadcrumbs"/>
    </template>
    <template #main_content>
      <div class="width-100 h2-headline text-start mt-5 mb-8">
        {{ itemId ? $t('Automation.EditRule') : $t('Automation.CreateRule') }}
      </div>
      <sForm
        ref="addAutomation"
        class="add-automation__content"
        :disabled="loading || isLocked"
        label-position="top"
        label-width="100px"
        :model="item"
        :rules="rules">
        <div class="add-automation__card">
          <sFormItem
            class="add-automation__card-row"
            :label="$t('Automation.Name')"
            prop="title">
            <sInput
              clearable
              data-qa="title"
              :placeholder="$t('Common.EnterName')"
              :value.sync="item.title"/>
          </sFormItem>
          <sFormItem
            class="mt-2"
            :label="$tc('Automation.Active', 0)"
            prop="isActive">
            <sRadioGroup
              v-model="item.isActive"
              class="mt-1"
              data-qa="radio-group-active"
              row>
              <sRadio
                data-qa="radio-group-active-no"
                :label="false">
                {{ $t('Tenders.No') }}
              </sRadio>
              <sRadio
                class="ml-13"
                data-qa="radio-group-active-yes"
                :label="true">
                {{ $t('Tenders.Yes') }}
              </sRadio>
            </sRadioGroup>
          </sFormItem>
          <sFormItem
            v-if="mixin_isGodMode"
            class="mt-2"
            :label="$tc('Automation.Locked', 0)"
            prop="isLocked">
            <sRadioGroup
              v-model="item.isLocked"
              class="mt-1"
              data-qa="radio-group-locked"
              row>
              <sRadio
                data-qa="radio-group-locked-no"
                :label="false">
                {{ $t('Tenders.No') }}
              </sRadio>
              <sRadio
                class="ml-13"
                data-qa="radio-group-locked-yes"
                :label="true">
                {{ $t('Tenders.Yes') }}
              </sRadio>
            </sRadioGroup>
          </sFormItem>
          <sAlert
            v-else-if="isLocked"
            small>
            {{ $t('Automation.automationBlocked') }}
          </sAlert>
        </div>
        <div class="add-automation__card">
          <div class="add-automation__card-when">
            {{ $t('Automation.When') }}
          </div>
          <sFormItem
            class="add-automation__card-row"
            prop="trigger.triggerTypeName"
            required>
            <span
              slot="label"
              class="add-automation__card-label">{{ $t('Automation.EventWillHappen') }}</span>
            <div
              v-if="trigerComponent && !trigerComponent.isAccess"
              class="add-automation__service-component">
              {{ $t(`Automation.trigger.${item.trigger.triggerTypeName}`) }}
            </div>
            <sSelect
              v-else-if="sprTriggers"
              class="width-100"
              data-qa="trigger"
              :disabled="loading || isLocked"
              filterable
              :placeholder="$t('Common.Select')"
              :value.sync="item.trigger.triggerTypeName">
              <template
                v-for="trigger in sprTriggers">
                <sOption
                  v-if="trigger.isAccess"
                  :key="`trigger-${trigger.key}`"
                  :class="{'px-8': true, 'bold': trigger.isService}"
                  :data-qa="`option-${trigger.key}`"
                  :disabled="loading || isLocked"
                  :label="$t(`Automation.trigger.${trigger.key}`)"
                  :value="trigger.key"/>
              </template>
            </sSelect>
          </sFormItem>
          <component
            v-if="trigerComponent && trigerComponent.component"
            :is="trigerComponent.component"
            ref="trigerComponent"
            class="add-automation__card-row"
            :disabled="trigerComponent.notExists || isLocked || !trigerComponent.isAccess"
            :value.sync="item.trigger.parameters"/>
          <template
            v-if="sprConditions && sprConditions.length && item.conditions && item.conditions.length">
            <template
              v-for="(condition, conditionIndex) in conditionComponents">
              <sFormItem
                :key="`conditions${conditionIndex}-conditionType`"
                class="add-automation__card-row"
                :data-qa="`conditions${conditionIndex}-conditionType`"
                :prop="`conditions[${conditionIndex}].conditionTypeName`"
                required>
                <span
                  slot="label"
                  class="add-automation__card-label">{{ $t('Automation.AndWhenCondition') }}
                  <sButton
                    v-if="!isLocked"
                    class="add-automation__card-btn"
                    icon="delete"
                    small
                    type="text"
                    @click="deleteItem(conditionIndex, 'conditions')"/>
                </span>
                <div
                  v-if="condition.component && isLocked"
                  class="add-automation__service-component">
                  <template v-if="item.conditions[conditionIndex].conditionType === 'TENDER_FIELD'">
                    {{ sprConditionsGroup.tenderFields.find(i => i.key === item.conditions[conditionIndex].condidionField)?.label }}
                  </template>
                  <template v-else-if="item.conditions[conditionIndex].conditionType === 'ADDITIONAL_FIELD'">
                    {{ sprConditionsGroup.additionalFields.find(i => i.key === item.conditions[conditionIndex].condidionField)?.label }}
                  </template>
                  <template v-else>
                    {{ $t(`Automation.condition.${item.conditions[conditionIndex].condidionField}`) }}
                  </template>
                </div>
                <sSelect
                  v-else
                  class="width-100 mt-1"
                  data-qa="condition"
                  :disabled="loading || isLocked"
                  :filterable="!condition.notExists"
                  :placeholder="$t('Common.Select')"
                  :value="item.conditions[conditionIndex].condidionField"
                  @update:value="val => updateConditionalField(conditionIndex, val)">
                  <sOptionGroup
                    key="sprConditionsGroup.tenderFields"
                    :label="$t('Automation.TenderFields')">
                    <sOption
                      v-for="conditionItem in sprConditionsGroup.tenderFields"
                      :key="conditionItem.key"
                      class="px-8"
                      :data-qa="`option-${conditionItem.key}`"
                      :disabled="loading || isLocked"
                      :label="conditionItem.label"
                      :value="conditionItem.key">
                      <div>
                        <div>{{ $t(`Automation.condition.${conditionItem.key}`) }}</div>
                        <div
                          v-if="conditionItem.description"
                          class="font-size-12 opacity-8">
                          {{ conditionItem.description }}
                        </div>
                      </div>
                    </sOption>
                  </sOptionGroup>
                  <sOptionGroup
                    key="sprConditionsGroup.additionalField"
                    :label="$t('Automation.CustomFields')">
                    <sOption
                      v-for="conditionItem in sprConditionsGroup.additionalFields"
                      :key="conditionItem.key"
                      class="px-8"
                      :data-qa="`option-${conditionItem.key}`"
                      :disabled="loading || isLocked"
                      :label="conditionItem.label"
                      :value="conditionItem.key">
                      <div>
                        <div>{{ conditionItem.label }}</div>
                        <sChip
                          v-if="conditionItem.additionalProps && conditionItem.additionalProps.typeId"
                          class="font-size-12 opacity-8">
                          {{ conditionItem.additionalProps.typeId }}
                        </sChip>
                      </div>
                    </sOption>
                  </sOptionGroup>
                </sSelect>
              </sFormItem>
              <component
                v-if="condition.component"
                :is="condition.component"
                :key="`conditions${conditionIndex}-component`"
                ref="conditionComponent"
                :additional-props="condition.additionalProps"
                class="add-automation__card-row"
                :disabled="condition.notExists || isLocked"
                :operators="condition.operators"
                :value="condition.value"
                @update:value="value => updateCondition(conditionIndex, value)"/>
            </template>
          </template>
          <sButton
            v-if="!isLocked"
            class="mt-1"
            :disabled="loading"
            icon="plus"
            type="text"
            @click="addedItem('conditions')">
            {{ $t('Automation.AddCondition') }}
          </sButton>
          <sDivider/>
          <div class="add-automation__card-when mt-4">
            {{ $t('Automation.Then') }}
          </div>
          <template
            v-if="sprActions.length && item.actions && item.actions.length">
            <template
              v-for="(action, actionIndex) in actionComponents">
              <div
                :key="`actions${actionIndex}-actionType`">
                <sFormItem
                  :data-qa="`actions${actionIndex}-actionType`"
                  :prop="`actions[${actionIndex}].actionTypeName`"
                  required>
                  <span
                    slot="label"
                    class="add-automation__card-label">{{ $t('Automation.ThenAction') }}
                    <sButton
                      v-if="!action.component || action.isAccess"
                      class="add-automation__card-btn"
                      icon="delete"
                      small
                      type="text"
                      @click="deleteItem(actionIndex, 'actions')"/>
                  </span>
                  <div
                    v-if="action.component && !action.isAccess"
                    class="add-automation__service-component">
                    {{ $t(`Automation.action.${actionComponents[actionIndex].value.actionTypeName}`) }}
                  </div>
                  <sSelect
                    v-else
                    class="add-automation__card-row width-100 mt-1"
                    data-qa="action"
                    :disabled="loading || isLocked"
                    :filterable="!action.notExists"
                    :placeholder="$t('Common.Select')"
                    :value="item.actions[actionIndex].actionTypeName"
                    @update:value="val => updateActionField(actionIndex, val)">
                    <template v-for="actionItem in sprActions">
                      <sOption
                        v-if="actionItem.isAccess"
                        :key="`action-${actionItem.key}`"
                        :class="{'px-8': true, 'bold': actionItem.isService}"
                        :data-qa="`option-${actionItem.key}`"
                        :disabled="loading || isLocked"
                        :label="$t(`Automation.action.${actionItem.key}`)"
                        :value="actionItem.key"/>
                    </template>
                  </sSelect>
                </sFormItem>
                <component
                  v-if="action.component"
                  :is="action.component"
                  :key="`actions${actionIndex}-component`"
                  ref="actionsComponent"
                  :additional-props="action.additionalProps"
                  class="width-100"
                  :disabled="action.notExists || isLocked || !action.isAccess"
                  :value="action.value"
                  @changeValidateResult="setValidateResult"
                  @update:value="value => updateAction(actionIndex, value)"/>
              </div>
            </template>
          </template>
          <sButton
            v-if="!isLocked"
            class="mt-1"
            :disabled="loading"
            icon="plus"
            type="text"
            @click="addedItem('actions')">
            {{ $t('Automation.AddAction') }}
          </sButton>
        </div>
      </sForm>
      <div
        v-if="mixin_isGodMode"
        class="flex">
        <KeyValue
          v-if="item.modifiedBy"
          caption="Хто"
          class="font-size-12"
          line
          :value="item.modifiedBy"/>
        <KeyValue
          v-if="modifiedAt"
          caption="Коли"
          class="font-size-12"
          line
          :value="modifiedAt"/>
      </div>
    </template>
    <template #footer>
      <ComponentFooter
        key="footer"
        :back="close"
        :back_btn="isLocked ? $t('Common.Close') : $t('Common.Cancel')"
        :loading="loading"
        :next="apply"
        :next_btn="itemId ? $t('Common.Save') : $t('Common.Create')"
        :next_disable="isLocked"/>
    </template>
  </ComponentLayout>
</template>
<script>
import Vue from 'vue'

import KeyValue from 'components/common/KeyValue.vue'
import ComponentLayout from 'pages/templates/ComponentLayout.vue'
import Breadcrumbs from 'components/common/elements/Breadcrumbs.vue'
import ComponentFooter from 'components/common/blocks/ComponentFooter.vue'
import automations from 'mixins/automations'
import textFunctions from 'mixins/textFunctions'
import godModeMixin from 'mixins/godModeMixin'

import { eventBus } from '@/main'

import AutomationsApi from '@/api/automationsApi'
const automations_api = new AutomationsApi()

const itemTemplate = {
  id: null,
  title: '',
  isLocked: false,
  isActive: false,
  trigger: {
    triggerTypeName: null,
    parameters: ''
  },
  conditions: [],
  actions: []
}
export default {
  name: 'addChangeAutomation',
  mixins: [ automations, textFunctions, godModeMixin ],
  data() {
    const that = this
    return {
      loading: true,
      breadcrumbs: [],
      itemId: null,
      sprConditionsGroup: {
        tenderFields: [],
        additionalFields: []
      },
      rules: {},
      item: {
        id: null,
        title: '',
        trigger: {
          triggerTypeName: null,
          parameters: ''
        },
        conditions: [],
        actions: []
      },
      titleRules: {
        required: true,
        trigger: 'change',
        validator(rule, value, callback) {
          if (!that.item.title) {
            callback(new Error(that.$t('Validate.Required')))
          }
          callback()
        },
      },
      externalValid: {},
    }
  },
  methods: {
    setValidateResult(value) {
      this.$set(this.externalValid, value.type, value.result)
    },
    addedItem(propName) {
      this.item[propName].push({})
      this.updateRules()
    },
    deleteItem(index, prop) {
      const result = this.$_.cloneDeep(this.item)
      result[prop].splice(index, 1)
      this.item = result
    },
    convertModelPropName(model) {
      if (!model) {
        return model
      }
      model.trigger.triggerTypeName = this.$_convertToCamelCase(model.trigger?.triggerType) || null
      model.conditions.forEach(condition => {
        condition.conditionTypeName = this.$_convertToCamelCase(condition.conditionType) || null
      })
      model.actions.forEach(action => {
        action.actionTypeName = this.$_convertToCamelCase(action.actionType) || null
      })

      return model
    },
    convertModelPropNameToSend(model) {
      if (!model) {
        return model
      }
      if (!this.itemId) {
        delete model.id
      }
      model.trigger.triggerType = this.$_convertToUpperCaseWithUnderscore(model.trigger.triggerTypeName)
      model.trigger.parameters = model.trigger.parameters || '{}'
      delete model.trigger.triggerTypeName
      delete model['__typename']
      delete model['modifiedBy']
      delete model['modifiedAt']
      delete model.trigger['__typename']
      model.conditions.forEach(condition => {
        condition.conditionType = this.$_convertToUpperCaseWithUnderscore(condition.conditionTypeName)
        condition.parameters = condition.parameters || '[]'
        delete condition.conditionTypeName
        delete condition['__typename']
      })
      model.actions.forEach(action => {
        action.actionType = this.$_convertToUpperCaseWithUnderscore(action.actionTypeName)
        action.parameters = action.parameters || '{}'
        delete action.actionTypeName
        delete action['__typename']
      })

      return model
    },
    async getData() {
      if (this.itemId) {
        await automations_api.api_getAutomation(this.itemId)
          .then(res => {
            this.item = this.convertModelPropName(res)
            this.updateRules()
          })
          .finally(() => {
            this.loading = false
          })
      } else {
        const item = this.$_.cloneDeep(itemTemplate)
        if (this.mixin_isGodMode) {
          item.isLocked = true
        }
        this.item = item
        this.loading = false
        this.updateRules()
      }
    },
    close() {
      this.$router.push({name: 'automationsPage', params: {org: this.$route.params.org}})
    },
    async beforeApply() {
      for (let i = 0; i < this.$refs.actionsComponent?.length; i++) {
        if (this.$refs.actionsComponent[i].beforeApply) {
          await this.$refs.actionsComponent[i].beforeApply()
        }
      }
      return
    },
    async apply() {
      if (this.isLocked) {
        return
      }
      await this.beforeApply()
      await this.$refs.addAutomation.validate(async (valid) => {
        const externalValid = Object.values(this.externalValid).filter(i => !i)?.length === 0
        if (valid && externalValid) {
          this.loading = true
          const apiName = this.itemId ? 'api_updateAutomation' : 'api_createAutomation'
          let mode = this.$_.cloneDeep(this.item)
          mode = this.convertModelPropNameToSend(mode)
          automations_api[apiName](mode)
            .then((result) => {
              if (result) {
                this.$router.push({name: 'automationsPage'})
              } else {
                this.$notice.warning({
                  title: this.$t('Common.ErrorTitle'),
                  message: this.$t('Errors.STHWrong'),
                  showClose: true,
                  progress: true,
                  duration: 10
                })
              }
            })
            .catch(error => {
              eventBus.$emit('showErrorSnackbar', error)
              Vue.prototype.$log_error(error.message)
            })
            .finally(() => {
              this.loading = false
            })
        }
      })
    },
    updateRules() {
      const that = this
      const result = this.$_.cloneDeep(this.rules)
      const getRequired = () => {
        return {
          type: 'string',
          required: true,
          trigger: 'change',
          validator(rule, value, callback) {
            if (!value) {
              callback(new Error(that.$t('Validate.Required')))
              return
            }
            callback()
          },
        }
      }
      result['title'] = [getRequired()]
      result['trigger.triggerTypeName'] = [getRequired()]
      this.item.conditions.forEach((condition, conditionIndex) => {
        result[`conditions[${conditionIndex}].conditionTypeName`] = [
          getRequired(),
          {
            trigger: 'change',
            validator(rule, value, callback) {
              if (that.conditionComponents[conditionIndex].notExists) {
                callback(new Error(that.$t('Automation.ConditionNotFindInSetting')))
                return
              }
              callback()
            },
          }
        ]
      })
      this.item.actions.forEach((action, actionIndex) => {
        result[`actions[${actionIndex}].actionTypeName`] = [
          getRequired(),
          {
            trigger: 'change',
            validator(rule, value, callback) {
              if (that.actionComponents[actionIndex].notExists) {
                callback(new Error(that.$t('Automation.ActionNotFindInSetting')))
                return
              }
              callback()
            },
          }
        ]
      })

      this.$set(this, 'rules', result)
      this.$nextTick(() => {
        this.$refs.addAutomation.clearValidate()
      })
    },
    /**
     * регистрируем или удаляем все компоненты автоматизации
     * что б не прописывать их все руками
     */
    registerComponents(unregister) {
      const register = (requireComponent, type, unregister) => {
        requireComponent.keys().forEach(fileName => {
          const componentConfig = requireComponent(fileName)

          const componentName = type + fileName
            .split('/')
            .pop()
            .replace(/\.\w+$/, '')

          if (unregister) {
            delete Vue.options.components[componentName]
          } else {
            Vue.component(componentName, componentConfig.default || componentConfig)
          }
        })
      }
      register(require.context('components/automation/triggers', false, /\.vue$/), 'trigger_', unregister)
      register(require.context('components/automation/actions', false, /\.vue$/), 'action_', unregister)
      register(require.context('components/automation/conditions', false, /\.vue$/), 'condition_', unregister)
    },
    updateAction(actionIndex, value) {
      this.$set(this.item.actions, actionIndex, value)
    },
    updateConditionalField(conditionIndex, condidionField) {
      const condition = this.sprConditions.find(i => i.key === condidionField)
      const result = this.$_.cloneDeep(this.item.conditions[conditionIndex])
      result.condidionField = condidionField
      result.conditionTypeName = condition.condition
      result.parameters = '[]'
      result.compareType = null
      this.$set(this.item.conditions, conditionIndex, result)
    },
    updateActionField(actionIndex, actionField) {
      const result = this.$_.cloneDeep(this.item.actions[actionIndex])
      result.actionTypeName = actionField
      result.parameters = '{}'
      this.$set(this.item.actions, actionIndex, result)
    },
    updateCondition(conditionIndex, value) {
      this.$set(this.item.conditions, conditionIndex, value)
    },
    createSprConditions() {
      let result = this.mixin_tenderFields
        .map(i => ({
          key: i.label,
          operators: i.operators,
          condition: 'tenderField',
          label: this.$t(`Automation.condition.${i.label}`)
        })) || []
      this.sprConditionsGroup.tenderFields = this.$_.cloneDeep(result)
        .sort((a,b) => a.label?.localeCompare(b.label))
      if (this.$_additionalFields?.length) {
        const spr = this.$_additionalFields
          .map(i => ({
            key: `${i.id}`,
            condition: 'additionalField',
            label: i.caption,
            additionalProps: i,
            description: this.$t('Automation.CustomFields')
          }))
        this.sprConditionsGroup.additionalFields = spr
          .sort((a,b) => a.label?.localeCompare(b.label))
      }
    }
  },
  computed: {
    isLocked() {
      return this.item.isLocked && !this.mixin_isGodMode
    },
    trigerComponent() {
      if (!this.item?.trigger?.triggerTypeName) {
        return null
      }
      const componentTrigerName = 'trigger_' + this.item.trigger.triggerTypeName
      const componentExists = !!Vue.component(componentTrigerName)
      const component = componentExists ? componentTrigerName : 'trigger_emptyTriggerParams'

      const isService = this.service_spr.triggers[this.item.trigger.triggerTypeName]
      return {
        component,
        notExists: !componentExists,
        isAccess: this.mixin_isGodMode || (!this.isLocked && !isService),
        isService: isService
      }
    },
    conditionComponents() {
      if (!this.item?.conditions?.length) {
        return []
      }
      const result = []
      this.item.conditions.forEach((condition) => {
        let componentConditionName
        let notExists
        let sprCondition
        if (condition.conditionTypeName) {
          componentConditionName = 'condition_' + condition.conditionTypeName
          if (!Vue.component(componentConditionName)) {
            componentConditionName = 'condition_emptyConditionParams'
          }
          sprCondition = this.sprConditions.find(i => i.key === condition.condidionField)
          notExists = !sprCondition
        }
        result.push({
          component: componentConditionName,
          value: condition,
          operators: notExists ? this.mixin_operators : sprCondition?.operators,
          notExists,
          additionalProps: sprCondition?.additionalProps,
        })
      })
      return result
    },
    actionComponents() {
      if (!this.item?.actions?.length) {
        return []
      }
      const result = []
      this.item.actions.forEach((action) => {
        let componentActionName
        let sprAction
        let additionalProps
        if (action.actionTypeName) {
          componentActionName = 'action_' + action.actionTypeName
          if (!Vue.component(componentActionName)) {
            componentActionName = 'action_emptyActionParams'
          }
          sprAction = this.sprActions.find(i => i.key === action.actionTypeName)

          if (action.actionTypeName === 'updateField' || action.actionTypeName === 'updateAdditionalField') {
            additionalProps = this.$_additionalFields
          }
        }
        result.push({
          component: componentActionName,
          value: action,
          notExists: !sprAction,
          additionalProps,
          isAccess: sprAction?.isAccess
        })
      })
      return result
    },
    sprTriggers() {
      if (!this.mixin_spr?.triggers?.length) {
        return []
      }
      return this.mixin_spr.triggers
        .map(tigger => {
          const isService = this.service_spr.triggers[tigger]
          return {
            key: tigger,
            isService: !!isService,
            isAccess: this.mixin_isGodMode || (!this.isLocked && !isService)
          }
        })
    },
    sprActions() {
      if (!this.mixin_spr?.actions?.length) {
        return []
      }
      return this.mixin_spr.actions
        .map(action => {
          const isService = this.service_spr.actions[action]

          return {
            key: action,
            isService: !!isService,
            isAccess: this.mixin_isGodMode || (!this.isLocked && !isService)
          }
        })
    },
    sprConditions() {
      return this.sprConditionsGroup.tenderFields
        .concat(this.sprConditionsGroup.additionalFields)
        .sort((a,b) => a.label?.localeCompare(b.label))
    },
    modifiedAt() {
      if (!this.item.modifiedAt) {
        return ''
      }
      return `${this.$d(new Date(this.item.modifiedAt), 'shortDate')} ${this.$d(new Date(this.item.modifiedAt), 'time')}`
    }
  },
  async mounted() {
    if (!this.$_accessAutomations) {
      this.$router.push({name: 'page-error', params: { status_code: '403', descript: 'Нет доступа в add or change automation' } })
      return
    }
    this.registerComponents()

    this.itemId = this.$route.params?.id
    this.breadcrumbs = [
      {
        text: this.$t('Menu.Automation'),
        to: {name: 'automationsPage', params: {org: this.$route.params.org}}
      },
      {
        text: this.itemId ? this.$t('Automation.EditRule') : this.$t('Automation.CreateRule'),
      },
    ]
    this.$_getAdditionalFields()
      .finally(() => {
        this.createSprConditions()
        this.getData()
      })
  },
  components: {
    KeyValue,
    Breadcrumbs,
    ComponentLayout,
    ComponentFooter,
  },
}
</script>
<style scoped lang="scss">
::v-deep .sFormItem__label {
  line-height: 1;
}
::v-deep .sFormItem:not(.is-hide-message) {
  margin-bottom: 14px;
}
.add-automation {
  &__content {
    width: 100%;
  }
  &__card {
    background-color: var(--v-main__light_green-base);
    border-color: var(--v-main__light_green-base);
    border-radius: 8px;
    text-align: left;
    padding: 20px 25px;
    margin-bottom: 10px;
    &-when {
      font-weight: 500;
      font-size: 16px;
      line-height: 20px;
      margin-bottom: 5px;
      padding-bottom: 10px;
    }
    &-row {
      width: 300px;
      //margin-top: 15px;
    }
    &-btn {
      min-height: 20px;
      min-width: 20px;
    }
    &-label {
      text-transform: uppercase;
      font-size: 11px;
      line-height: 14px;
      color: #6A8382;
    }
  }
  &__service-component {
    background-color: var(--secondary__green_locked);
    border-radius: 31px;
    border: 2px solid var(--main__green_locked);
    color: var(--text-color);
    display: inline-block;
    height: 40px;
    line-height: 38px;
    padding: 0 15px;
    cursor: not-allowed;
    width: 300px;
  }
}
</style>
